import { State } from ".";
import { getHasDirtyDates } from "./sync.selectors";
import { getIsAuthorized } from "./user.selectors";

export type SyncIndicator = `synced` | `pending` | `syncing` | `error` | null;

export const getSyncIndicator = (state: State): SyncIndicator => {
    if (!getIsAuthorized(state)) {
        return null;
    }
    if (state.ui.syncStatus === `syncing`) {
        return `syncing`;
    }
    if (state.ui.syncStatus === `error`) {
        return `error`;
    }
    if (getHasDirtyDates(state)) {
        return `pending`;
    }
    return `synced`;
};
